import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "a119cb94-f9b3-41a3-95ba-ad0e10f5499f",
    content: "Discrete convolution always has a rather low latency.",
    options: {},
  },
  {
    id: "45032f2f-0720-4500-a7d7-b35cfc31906b",
    content: "FIR filters have an infinite impulse response.",
    options: {},
  },
  {
    id: "9e09c745-79e9-4181-891f-c8e5753c9273",
    content: "Computational load for direct convolution is quite high.",
    options: {},
  },
  {
    id: "b76c5d88-19d8-4a10-b7c5-eecfd51eab79",
    content: "A direct convolution with 34 samples is as complex as a direct convolution with 64 samples.",
    options: {},
  },
  {
    id: "e06c8f67-c627-4ba8-983b-2bd16965738d",
    content: "An FFT with 34 samples is as complex as an FFT with 64 samples.",
    options: {},
  },
];

export const task: Task = {
  id: "1e8aecd4-d1d8-4434-8eca-15cc80da3e38",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "a119cb94-f9b3-41a3-95ba-ad0e10f5499f",
    "9e09c745-79e9-4181-891f-c8e5753c9273",
    "e06c8f67-c627-4ba8-983b-2bd16965738d",
  ],
};
